<template>
  <UiBtn
    v-badge="{
      show: isShowFilterButtonBadge,
      style: {
        border: '2px solid var(--black-500)',
        top: '4px',
        right: '4px',
        height: '7px',
        width: '7px',
        backgroundColor: 'var(--badge-error-icon-dot-color)',
      },
    }"
    class="filter-button"
    :size="{
      default: 's',
      tablet: 'm',
    }"
    :active="get_filterOptions.isOpen"
    icon="lobby/filter"
    color="gray"
    @click="write_filterOptions({ isOpen: true })"
  >
    <span class="filter-button__text" :class="{ 'hidden-mob' : hiddenTextMob }">
      {{ $tc('lobby.filter.title') }}
    </span>
  </UiBtn>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FilterButton',
  props: {
    hiddenTextMob: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters('lobby', [
      'get_filterOptions',
      'get_filterType',
    ]),
    isShowFilterButtonBadge() {
      return Boolean(this.get_filterOptions.isFiltered)
    },
  },
  methods: {
    ...mapActions('lobby', ['write_filterOptions']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
